module.exports = __webpack_public_path__ + "img/ico1.ef47738b.png";